import { RouteProps } from 'react-router';
import ProfileDetails from '../ProfileDetails';
import FatcaEditDetails from '../ProfileDetails/FatcaEditDetails';
import NomineeDetailsPurchase from '../ProfileDetails/NomineeDetailsPurchase';
import OtpVerification from './mf-investment-otp';
import UpdateBankDetailsPurchase from '../ProfileDetails/UpdateBankDetailsPurchase';
import UpdatenomineePurchase from '../ProfileDetails/updatenomineePurchase';
import SchemeDetails from './explore-mf-details';
import Explore from './explore-mf-filters';
import Purchase from './index';
import Invest from './mf-investment';
import MfPayment from './mf-payment';
import MfSuccess from './mf-success';
import OtmPaymentSuccess from './OtmPaymentSuccess';
import { ExplorePaths } from './types';
import MfProspectSuccess from './mf-prospect-success';

const Routes: RouteProps[] = [
    {
        path: ExplorePaths.NewPurchase,
        component: Purchase,
    },
    {
        path: ExplorePaths.Explore,
        component: Explore,
        exact: true,
    },
    {
        path: ExplorePaths.SchemeDetails,
        component: SchemeDetails,
        exact: true,
    },
    {
        path: ExplorePaths.Invest,
        component: Invest,
    },
    {
        path: ExplorePaths.ProfileDetails,
        component: ProfileDetails,
        exact: true,
    },
    {
        path: ExplorePaths.EditBank,
        component: UpdateBankDetailsPurchase,
    },
    {
        path: ExplorePaths.EditNominee,
        component: UpdatenomineePurchase,
    },
    {
        path: ExplorePaths.EditFatca,
        component: FatcaEditDetails,
    },

    {
        path: ExplorePaths.PaymentMethod,
        component: MfPayment,
    },
    {
        path: ExplorePaths.PaymentStatus,
        component: MfSuccess,
    },
    {
        path: ExplorePaths.OTMPaymentStatus,
        component: OtmPaymentSuccess,
    },
    {
        path: ExplorePaths.OtpVerify,
        component: OtpVerification,
    },
    {
        path: ExplorePaths.ProspectPaymentStatus,
        component: MfProspectSuccess,
    }
];

export { Routes as NewPurchaseRoutes };
